import SDTSxSKmoTk from './SDTSxSKmoTk.png'
import w_2ADRxM2Dg from './w_2ADRxM2Dg.png'
import _YaudMDQQqw from './_YaudMDQQqw.png'
import w4odMcvzKOQ from './w4odMcvzKOQ.png'

export const previews = {
  SDTSxSKmoTk,
  w_2ADRxM2Dg,
  _YaudMDQQqw,
  w4odMcvzKOQ,
}
